(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mask-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const tabBtns = document.querySelectorAll('.mask-tabs__btn');
    const tabPanels = document.querySelectorAll('.mask-tabs__panel');

    tabBtns.forEach((btn) => {
      btn.addEventListener('click', function () {
        const targetTab = this.getAttribute('data-tab');
        const targetPanel = document.querySelector(`[data-panel="${targetTab}"]`);
        const currentActive = document.querySelector('.mask-tabs__panel.active');

        // Don't do anything if clicking the already active tab
        if (targetPanel === currentActive) return;

        // Remove active class from all buttons
        tabBtns.forEach((b) => b.classList.remove('active'));
        this.classList.add('active');

        // Fade out current panel first
        if (currentActive) {
          currentActive.classList.add('fading-out');
          currentActive.classList.remove('active');
        }
        
        // Wait for fade out to complete, then fade in new panel
        setTimeout(() => {
          if (currentActive) {
            currentActive.classList.remove('fading-out');
          }
          targetPanel.classList.add('active');
        }, 400);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-header"] && !Shopify.designMode) return;
  try {
    
(function() {
    document.querySelector(".name-field").addEventListener("input", function () {
        this.value = this.value.replace(/[^a-zA-Z\s]/g, '');
    });

    const meTooBtn = document.getElementById('meTooBtn');
    const popup = document.getElementById('meTooPopup');
    const closeBtn = document.getElementById('closePopup');

    // Open popup
    function openPopup() {
        popup.classList.add('active');
        document.body.style.overflow = 'hidden';
    }

    meTooBtn.addEventListener('click', openPopup);

    // Close popup
    function closePopup() {
        popup.classList.remove('active');
        document.body.style.overflow = '';
        // Clean up URL if form was submitted
        if (window.location.search.includes('contact_posted=true')) {
            const url = window.location.pathname;
            window.history.replaceState({}, document.title, url);
        }
    }

    closeBtn.addEventListener('click', closePopup);

    popup.addEventListener('click', function(e) {
        if (e.target === popup) {
            closePopup();
        }
    });

    // Close on escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && popup.classList.contains('active')) {
            closePopup();
        }
    });

    // Auto-open popup if form was just submitted
    if (window.location.search.includes('contact_posted=true') || window.location.hash.includes('ContactForm')) {
        openPopup();
    }
})();

  } catch(e) { console.error(e); }
})();
})();
